import SearchBox from './components/autosuggest';
import './App.css';

function App() {
  return (
    <div className="app">
      <h2>Welcome to autosuggest highlight app</h2>
      <SearchBox />
    </div>
  );
}

export default App;
